import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { BtnPrimary } from "../../share/buttons/Btn";
import Card from "../../share/cards/Card";
import AdminPagination from "../../share/Pageination/AdminPagination";
import { ReactComponent as Trash } from "../../../Assets/Image/svg/trash.svg";
import { ReactComponent as Edit } from "../../../Assets/Image/svg/edit.svg";
import { ReactComponent as Add } from "../../../Assets/Image/svg/addSession.svg";
import { Modal } from "../../share/modal/Modal";
import IconButton from "../../share/buttons/IconButton";
import useFetch from "../../../Hooks/useFetch";
import MainPagination from "../../share/Pageination/MainPagination";
import { useCreate } from "../../../Context/CreateContext";
import AddSessionCourse from "./AddSessionCourse";
import AddHomeworkCourse from "./AddHomeworkCourse";

const SessionsMain = () => {
    const [sessionInfo, setSessionInfo] = useState(false);
    const [homework, setHomework] = useState(false);
    const [sessions, setSessions] = useState();
    const [status, setStatus] = useState("");
    const [del, setDel] = useState();
    const [edit, setEdit] = useState();
    const [hwId, setHwId] = useState();
    const [pagination, setPagination] = useState({
        current: 1,
    });

    const getSessions = useFetch({
        method: "GET",
        url: `BootCampSessionService/11/sessions`,
        pagination: pagination,
        noHeader: false,
        trigger: true,
        setter: setSessions,
    });
    //TODO : id bootcamp dynamic she

    const deleteSession = useFetch({
        method: "DELETE",
        url: `BootCampSessionService/${del}`,
        noHeader: false,
        caller: getSessions,
    });

    useEffect(() => {
        getSessions.reFetch();
    }, [pagination]);

    const handleDelete = (id) => {
        setDel(id);
        deleteSession.reFetch();
    };
    const handleEdit = (id) => {
        setEdit(id);
        setStatus("edit");
        setSessionInfo((perv) => !perv);
    };

    const handleHomework = (id) => {
        setHwId(id);
    };

    const handleModalSession = () => {
        setHomework(false);
        setStatus("create");
        setSessionInfo((perv) => !perv);
    };

    const closeModalSession = () => {
        setSessionInfo((prev) => !prev);
    };

    const handleModalHomework = () => {
        setHomework(true);
    };

    const closeModalHomework = () => {
        setHomework((prev) => !prev);
    };
    return (
        <div className="p-16">
            <div className="text-sm breadcrumbs mb-20 overflow-hidden">
                <ul>
                    <li>
                        <Link to="/dashboard/bootcamps">بوت کمپ‌های من</Link>
                    </li>
                    <li>
                        <Link to="/dashboard/bootcamps">
                            طراحی تبلیغات دیجیتالی سازمانی برای سازمان‌های دولتی
                        </Link>
                    </li>
                    <li>جلسات</li>
                </ul>
            </div>
            <div className="flex justify-between items-center">
                <h4 className="text-[2rem] text-purple-dark font-bold">
                    اطلاعات جلسات بوت کمپ
                </h4>
                <BtnPrimary
                    text="+ ساخت جلسه جدید"
                    className="px-16 py-7"
                    onClick={() => handleModalSession()}
                />
            </div>
            <div className="mx-24 py-24">
                <Card className="SupportTicketTable-card SupportTicketTable-header ">
                    <div>نام جلسه</div>
                    <div></div>
                    <div></div>
                    <div></div>
                </Card>
                <div>
                    {sessions?.results.map((i) => (
                        <Card
                            key={i.id}
                            className="SupportTicketTable-card SupportTicketTable-body my-4"
                        >
                            <div className=" text-black-prim">
                                {i.session_name}
                            </div>
                            <div></div>
                            <div
                                className=" text-purple-dark cursor-pointer"
                                onClick={() => {
                                    handleModalHomework();
                                    handleHomework(i.id);
                                }}
                            >
                                ساخت تکلیف
                            </div>
                            <div className="">
                                {!i.checked && (
                                    <div className="flex justify-end">
                                        <IconButton
                                            onClick={() => handleDelete(i.id)}
                                            data-tip="حذف"
                                        >
                                            <Trash />
                                        </IconButton>
                                        <IconButton
                                            onClick={() => handleEdit(i.id)}
                                            data-tip="ویرایش"
                                        >
                                            <Edit />
                                        </IconButton>
                                    </div>
                                )}
                            </div>
                        </Card>
                    ))}
                </div>
                <MainPagination
                    pagination={pagination}
                    setPagination={setPagination}
                    data={sessions?.results}
                    pageSize={sessions?.page_count}
                    className="mt-[3rem]"
                />
            </div>
            <Modal show={sessionInfo} closeModal={closeModalSession} key={1}>
                <AddSessionCourse
                    sessionInfo={sessionInfo}
                    state={status}
                    getSessions={getSessions}
                    close={closeModalSession}
                    status={homework}
                    setStatus={setHomework}
                    id={edit}
                    setId={setEdit}
                />
            </Modal>
            <Modal show={homework} closeModal={closeModalHomework}>
                <AddHomeworkCourse
                    homework={homework}
                    sessionInfo={sessionInfo}
                    close={closeModalHomework}
                    id={hwId}
                    setId={setHwId}
                />
            </Modal>
        </div>
    );
};

export default SessionsMain;
